import React from "react";
import { Container } from "@material-ui/core";
import { useGetData, usePutData } from "hooks";
import * as Api from "service/index";
import { useTranslation } from "localization/translation";
import { OfferForm } from "./item";

const KINDS = [
  { kind: "international", titleKey: "public_offer_international" },
  { kind: "ru_by", titleKey: "public_offer_ru_by" },
];

const EMPTY_OFFERS = {
  international: {
    kind: "international",
    title_en: "",
    title_ru: "",
    title_hy: "",
    text_en: "",
    text_ru: "",
    text_hy: "",
  },
  ru_by: {
    kind: "ru_by",
    title_en: "",
    title_ru: "",
    title_hy: "",
    text_en: "",
    text_ru: "",
    text_hy: "",
  },
};

const PublicOffers = () => {
  const [data, , refresh] = useGetData(Api.publicOffers.getAll);
  const updateCallback = usePutData(Api.publicOffers.update, refresh);
  const translation = useTranslation();
  const byKind = Object.fromEntries(
    (data?.data || []).map((item) => [item.kind, item])
  );

  return (
    <Container>
      {KINDS.map(({ kind, titleKey }) => (
        <OfferForm
          key={kind}
          title={translation[titleKey]}
          initialData={byKind[kind] || EMPTY_OFFERS[kind]}
          onSave={updateCallback}
          fixedLang={kind === "ru_by" ? "ru" : undefined}
        />
      ))}
    </Container>
  );
};

export default PublicOffers;
